import Avatar from '../../components/Avatar';
import { UserCard } from '../../components/Card';
import Notifications from '../../components/Notifications';
import SearchInput from '../../components/SearchInput';
import { notificationsData } from '../../demos/header';
import withBadge from '../../hocs/withBadge';
import React from 'react';
import {
  MdClearAll,
  MdExitToApp,
  MdHelp,
  MdInsertChart,
  MdMessage,
  MdNotificationsActive,
  MdNotificationsNone,
  MdPersonPin,
  MdSettingsApplications,
} from 'react-icons/md';
import {
  Button,
  ListGroup,
  ListGroupItem,
  // NavbarToggler,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
  Form,
  Input,
} from 'reactstrap';
import bn from '../../utils/bemnames';
import axios from 'axios';
import StorageService from '../../services/StorageService';
import userImage from '../../assets/img/users/profile.jpg';
import companyImage from '../../assets/img/users/placeholder.jpg';

const bem = bn.create('header');

const MdNotificationsActiveWithBadge = withBadge({
  size: 'md',
  color: 'primary',
  style: {
    top: -10,
    right: -10,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  children: <small>5</small>,
})(MdNotificationsActive);

class Header extends React.Component {
  state = {
    isOpenNotificationPopover: false,
    isNotificationConfirmed: false,
    isOpenUserCardPopover: false,
    organisationList: [],
    company: '',
    companyLogo: '',
  };

  toggleNotificationPopover = () => {
    this.setState({
      isOpenNotificationPopover: !this.state.isOpenNotificationPopover,
    });

    if (!this.state.isNotificationConfirmed) {
      this.setState({ isNotificationConfirmed: true });
    }
  };

  toggleUserCardPopover = () => {
    this.setState({
      isOpenUserCardPopover: !this.state.isOpenUserCardPopover,
    });
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
    document.querySelector('.cr-page').classList.toggle('sidebar-open');
  };

  profile = () => {
    const { children } = this.props;
    //StorageService.setSession('activePath', '/profile');
    children.props.history.push('/profile');
  };

  organisation = () => {
    const { children } = this.props;
    //StorageService.setSession('activePath', '/company-information');
    children.props.history.push('/company-information');
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });

    if (event.target.value !== 'none') {
      const selected_org = this.state.organisationList.find(
        e => e.CompanyName === event.target.value,
      );
      if (selected_org) {
        this.getCompanyDetails(selected_org.CompanyID);
      }
      StorageService.clearSession('taskOrder');
      StorageService.clearSession('posreport');
      StorageService.clearSession('activeTab');
      StorageService.clearSession('searchOrder');
      StorageService.clearSession('PaymentReport');
      StorageService.clearSession('orderSummary');
      StorageService.clearSession('activeTab');
      StorageService.clearSession('OrderScheduleList');
      StorageService.clearSession('OrderSchedule');
      StorageService.clearSession('processStatus');
      StorageService.clearSession('SalesReport');
      // StorageService.setSession('selected_org', selected_org);
      // StorageService.setSession(
      //   'activeApp',
      //   selected_org.Features[0].RowOrder - 1,
      // );

      // window.location.href = '/';
    }
  };

  getCompanyDetails = id => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
      CompanyID: id,
    };

    axios
      .post(url + ':3000/v1/company/editUserCompany', data)
      .then(response => {
        const result = response.data;

        if (result.error == 'true' && result.message != 'Success') {
          alert(result.message);
          return;
        }

        StorageService.setSession('selected_org', result.data);
        StorageService.setSession(
          'activeApp',
          result.data.Features[0].RowOrder - 1,
        );

        window.location.href = '/';
      })
      .catch(error => {
        alert(error);
      });
  };

  getOrganisationList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const selected_org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/company/getUserCompany', data)
      .then(response => {
        const result = response.data;

        if (result.error == 'true' && result.message != 'Success') {
          alert(result.message);
          return;
        }

        this.setState({ organisationList: result.data });

        if (result.data.length > 0 && selected_org == null) {
          StorageService.setSession('selected_org', result.data[0]);
          this.setState({
            company: result.data[0].CompanyName,
            companyLogo: result.data[0].CompanyLogo,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    const selected_org = StorageService.getSession('selected_org');
    if (selected_org !== null) {
      this.setState({
        company: selected_org.CompanyName,
        companyLogo: selected_org.CompanyLogo,
      });
    }
    this.getOrganisationList();
  }

  render() {
    const { isNotificationConfirmed } = this.state;
    const isSelectOrg = StorageService.getSession('selected_org');
    const user = StorageService.getSession('user_info');

    return (
      <Navbar light expand className={bem.b('bg-white')}>
        <Nav navbar className="mr-2">
          <Button
            className="ps-button"
            outline
            onClick={this.handleSidebarControlButton}
          >
            <MdClearAll size={25} />
          </Button>
        </Nav>

        <Nav navbar className="d-flex">
          <Form className="ps-header-form">
            <Input
              type="select"
              name="company"
              id="company"
              value={this.state.company}
              onChange={this.changeHandler}
              style={{ minWidth: '180px' }}
              className="ps-header-input"
            >
              {this.state.organisationList.length > 0 &&
                this.state.organisationList.map((item, index) => {
                  return (
                    <option key={index} value={item.CompanyName}>
                      {item.CompanyName}
                    </option>
                  );
                })}
            </Input>
          </Form>
          <Avatar
            size={30}
            className="ml-2 my-auto"
            src={
              this.state.companyLogo === null || this.state.companyLogo === ''
                ? companyImage
                : this.state.companyLogo
            }
          />
        </Nav>

        <Nav navbar className={bem.e('nav-right')}>
          {/* <NavItem className="d-inline-flex">
            <NavLink id="Popover1" className="position-relative">
              {isNotificationConfirmed ? (
                <MdNotificationsNone
                  size={25}
                  className="text-secondary can-click"
                  onClick={this.toggleNotificationPopover}
                />
              ) : (
                <MdNotificationsActiveWithBadge
                  size={25}
                  className="text-secondary can-click animated swing infinite"
                  onClick={this.toggleNotificationPopover}
                />
              )}
            </NavLink>
            <Popover
              placement="bottom"
              isOpen={this.state.isOpenNotificationPopover}
              toggle={this.toggleNotificationPopover}
              target="Popover1"
            >
              <PopoverBody>
                <Notifications notificationsData={notificationsData} />
              </PopoverBody>
            </Popover>
          </NavItem> */}

          <NavItem>
            <NavLink id="Popover2">
              <Avatar
                onClick={this.toggleUserCardPopover}
                className="can-click"
                size={30}
                src={
                  user.photo === null || user.photo === ''
                    ? userImage
                    : user.photo
                }
              />
              <span className="avatar-popover">
                {user.name === null || user.name === ''
                  ? user.email
                  : user.name}
              </span>
            </NavLink>
            <Popover
              placement="bottom-end"
              isOpen={this.state.isOpenUserCardPopover}
              toggle={this.toggleUserCardPopover}
              target="Popover2"
              className="p-0 border-0"
              style={{ minWidth: 180 }}
            >
              <PopoverBody className="p-0 border-light">
                <ListGroup flush>
                  <ListGroupItem
                    tag="button"
                    action
                    className="border-light"
                    onClick={() => {
                      this.profile();
                      this.toggleUserCardPopover();
                    }}
                  >
                    <MdPersonPin /> Profile
                  </ListGroupItem>
                  <ListGroupItem
                    tag="button"
                    action
                    className="border-light"
                    onClick={() => {
                      this.organisation();
                      this.toggleUserCardPopover();
                    }}
                  >
                    <MdInsertChart /> Organisation
                  </ListGroupItem>
                  <ListGroupItem
                    tag="button"
                    action
                    className="border-light"
                    onClick={this.props.handleLogout}
                  >
                    <MdExitToApp /> Logout
                  </ListGroupItem>
                </ListGroup>
              </PopoverBody>
            </Popover>
          </NavItem>
        </Nav>
      </Navbar>
    );
  }
}

export default Header;
